import { lazyNamed } from 'src/utils/lazyNamed.ts';
import { EmailDesignFormSearchParams } from './pages/EmailDesignForm/types.ts';
import { EmailTemplateFormSearchParams } from './pages/EmailTemplateForm/types.ts';
import { PDFStylesFormSearchParams } from './pages/PDFStylesForm/types.ts';

export const CompanySettings = {
  // common
  Layout: lazyNamed(() => import('./components/Layout.tsx'), 'Layout'),
  SalesUnitsProvider: lazyNamed(() => import('./components/SalesUnitsProvider.tsx'), 'SalesUnitsProvider'),

  // pages
  CoopWeeks: lazyNamed(() => import('./pages/CoopWeeks/index.tsx'), 'CoopWeeks'),
  EmailTemplateForm: lazyNamed(() => import('./pages/EmailTemplateForm/index.tsx'), 'EmailTemplateForm'),
  EmailTemplates: lazyNamed(() => import('./pages/EmailTemplates/index.tsx'), 'EmailTemplates'),
  EmailDesigns: lazyNamed(() => import('./pages/EmailDesigns/index.tsx'), 'EmailDesigns'),
  EmailDesignForm: lazyNamed(() => import('./pages/EmailDesignForm/index.tsx'), 'EmailDesignForm'),
  PaymentDetails: lazyNamed(() => import('./pages/PaymentDetails/index.tsx'), 'PaymentDetails'),
  PaymentDetailsForm: lazyNamed(() => import('./pages/PaymentDetailsForm/index.tsx'), 'PaymentDetailsForm'),
  PDFFooterTemplates: lazyNamed(() => import('./pages/PDFFooterTemplates/index.tsx'), 'PDFFooterTemplates'),
  PDFStylesForm: lazyNamed(() => import('./pages/PDFStylesForm/index.tsx'), 'PDFStylesForm'),
  PDFStyles: lazyNamed(() => import('./pages/PDFStyles/index.tsx'), 'PDFStyles'),
  PDFTypeConfigurations: lazyNamed(() => import('./pages/PDFTypeConfigurations/index.tsx'), 'PDFTypeConfigurations'),
  PPTReportConfig: lazyNamed(() => import('./pages/PPTReportConfig/index.tsx'), 'PPTReportConfig'),
  Sequencing: lazyNamed(() => import('./pages/Sequencing/index.tsx'), 'Sequencing'),
  UserIdModules: lazyNamed(() => import('./pages/UserIdModules/index.tsx'), 'UserIdModules'),

  // search params
  EmailTemplateFormSearchParams,
  EmailDesignFormSearchParams,
  PDFStylesFormSearchParams,
};
